import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import HandleFormData from '~/utils/HandleFormData';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import ColoredFileInput from '~/componentes/CustomForm/FileInput/styles/ColoredFileInput';

import { Container } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import RecursosList from './RecursosList';
import PrioridadeListColor from './PrioridadeListColor';
import AtividadesList from './AtividadesList';
import AcessosList from './AcessosList';

function CreateEditContent({ mountedData }) {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const abas = [{ titulo: 'Projeto' }, { titulo: 'Processos' }, { titulo: 'Acessos' }];

  const [etapas, setEtapas] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [acessos, setAcessos] = useState([]);
  const [prioridade, setPrioridade] = useState({});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapa : 1);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [horaSaldo, setHoraSaldo] = useState(mountedData ? mountedData?.horaSaldo : 0);

  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');

  useEffect(() => {
    if (mountedData) {
      setHoraTotal(mountedData?.horaTotal);
      setHoraSaldo(mountedData?.horaSaldo);
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', { params: { ativo: 1, tipo: 'PRJ' } })
        .then(r => {
          setEtapas(r?.data);
          setIdEtapa(mountedData?.idEtapa);
        });
    } else {
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', {
          params: { ativo: 1, tipo: 'PRJ', posicao: 1 },
        })
        .then(r => {
          setEtapas(r?.data);
          if (r?.data?.length > 0) {
            setIdEtapa(r?.data[0]?.id);
          }
        });
    }
    api
      .get('/signed/empresa/suporte/contratos', { params: { ativo: 1, listContrato: true } })
      .then(r => setContratos(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
      .then(r => setClientes(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/coordenadores', { params: { ativo: 1 } })
      .then(r => setCoordenadores(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/produtos', { params: { ativo: 1 } })
      .then(r => setProdutos(r?.data));
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id &&
        api
          .get('/signed/empresa/gestorprojeto/gerencia/clientesolicitantes', {
            params: { ativo: 1, idCliente: cliente?.id },
          })
          .then(r => setSolicitantes(r?.data));
    } else {
      setSolicitantes([]);
    }
  }, [cliente]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData([file1, file2, file3, file4], {
          emailRespCliente: data?.emailRespCliente,
          valorTotal: data?.valorTotal,
          valorHora: data?.valorHora,
          dataInicioProjeto: data?.dataInicioProjeto,
          dataPrevEntregaProjeto: data?.dataPrevEntregaProjeto,
          descricaoProjeto: data?.descricaoProjeto,
          idCoordenador: data?.idCoordenador,
          idCoordenadorTec: data?.idCoordenadorTec,
          idClienteSolicitante: data?.idClienteSolicitante,
          tipoProjeto: data?.tipoProjeto,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          gerarProjeto,
          recursos,
          idEtapa,
          horaTotal,
          prioridade,
          atividades,
          acessos,
          removeArquivos,
        });

        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/projeto', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/projeto', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Projeto, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Projeto?`,
        successModal: `Projeto ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          {abas.map((thisVal, a) => (
            <div
              className={abaAtiva == a ? 'item-aba ativo' : 'item-aba'}
              onClick={() => setAbaAtiva(a)}
              key={thisVal?.titulo}
            >
              <span></span>
              <p>{thisVal?.titulo}</p>
            </div>
          ))}
        </div>
        {mountedData && (
          <div>
            <div className={abaAtiva == 0 ? 'item-modal ativo' : ' item-modal'}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Título *" className="col s8 m8 l8">
                      <Input
                        name="titulo"
                        disabled="true"
                        required="true"
                        defaultValue={mountedData?.titulo}
                      />
                    </Label>
                    <Label title="Data Solicitação *" className="col s4 m4 l4">
                      <Input
                        type="date"
                        disabled="true"
                        name="dataProjeto"
                        required="true"
                        defaultValue={mountedData?.dataProjeto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Cliente *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                        name="idCliente"
                        disabled="true"
                        firstOption
                        defaultValue={mountedData?.idCliente}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          const cliente = clientes?.find(e => e?.id == parseInt(v));
                          setCliente(cliente || {});
                        }}
                      />
                    </Label>
                    <Label title="Solicitante Cliente *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: solicitantes, value: 'id', label: 'nome' }}
                        name="idClienteSolicitante"
                        firstOption
                        defaultValue={mountedData?.idClienteSolicitante}
                      />
                    </Label>
                    <Label title="Produto *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        disabled="true"
                        list={{ list: produtos, value: 'id', label: 'titulo' }}
                        name="idProduto"
                        firstOption
                        defaultValue={mountedData?.idProduto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Tipo Projeto*" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Suporte' },
                            { id: 'B', titulo: 'Banco de Horas' },
                            { id: 'P', titulo: 'Projeto' },
                            { id: 'A', titulo: 'Avulso' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="tipoProjeto"
                        firstOption
                        defaultValue={mountedData?.tipoProjeto}
                      />
                    </Label>
                    <Label title="Aprovador 1 *" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenador"
                        firstOption
                        defaultValue={mountedData?.idCoordenador}
                      />
                    </Label>
                    <Label title="Aprovador 2*" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenadorTec"
                        firstOption
                        defaultValue={mountedData?.idCoordenadorTec}
                      />
                    </Label>
                    {/* <Label title="Contrato" className="col s12 m6 l4">
                        <Select
                          isString
                          list={{ list: contratos, value: "id", label: "titulo" }}
                          name="idContrato"
                          firstOption
                          defaultValue={mountedData?.idContrato}
                        />
                      </Label> */}
                  </div>
                  <div className="row no-margin">
                    <Label title="Descrição do Projeto" className="col s12 m12 l12">
                      <TextArea
                        name="descricaoProjeto"
                        defaultValue={mountedData?.descricaoProjeto}
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Envia Email *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Sim' },
                            { id: 'N', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="emailRespCliente"
                        defaultValue={mountedData?.enviaEmailSolicitante}
                      />
                    </Label>
                    <Label title="Data Inicio *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataInicioProjeto"
                        required="true"
                        defaultValue={mountedData?.previsaoInicio}
                      />
                    </Label>
                    <Label title="Data Prev Entrega *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataPrevEntregaProjeto"
                        required="true"
                        defaultValue={mountedData?.previsaoEntrega}
                      />
                    </Label>
                    <Label title="Ativo *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'true', titulo: 'Sim' },
                            { id: 'false', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="ativo"
                        defaultValue={mountedData?.ativo?.toString()}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          setAtivo(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Contrato" className="col s12 m6 l3">
                      <Select
                        isString
                        list={{ list: contratos, value: 'id', label: 'titulo' }}
                        name="idContrato"
                        firstOption
                        defaultValue={mountedData?.idContrato}
                      />
                    </Label>
                    {/* <Label title="Hora Lib *" className="col s12 m6 l3">
                        <Input
                          type="number"
                          name="horaSaldo"
                          required="true"
                          disabled="true"
                          min="1"
                          value={horaSaldo}
                        />
                      </Label> */}
                    <Label title="Hora Total *" className="col s12 m6 l3">
                      <Input
                        type="number"
                        name="horaTotal"
                        required="true"
                        disabled="true"
                        min="1"
                        value={horaTotal}
                      />
                    </Label>
                    <Label title="Valor Hora" className="col s12 m6 l3">
                      <Input
                        type="number"
                        name="valorHora"
                        required="false"
                        defaultValue={mountedData?.valorHora}
                      />
                    </Label>
                    <Label title="Valor Total *" className="col s12 m6 l3">
                      <Input
                        type="number"
                        name="valorTotal"
                        min="1"
                        required="true"
                        defaultValue={mountedData?.valorTotal}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <div className="col s12 m12 l12">
                      <RecursosList
                        setter={setRecursos}
                        defaultData={
                          typeof mountedData?.recurso == 'object'
                            ? mountedData?.recurso || []
                            : JSON.parse(mountedData?.recurso)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row no-margin">
                <Label title="Anexo 1" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo1"
                    defaultFile={mountedData?.anexo1}
                    formFile={setFile1}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 2" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo2"
                    defaultFile={mountedData?.anexo2}
                    formFile={setFile2}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 3" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo3"
                    defaultFile={mountedData?.anexo3}
                    formFile={setFile3}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 4" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo4"
                    defaultFile={mountedData?.anexo4}
                    formFile={setFile4}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
              </div>
            </div>
            <div className={abaAtiva == 1 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AtividadesList
                    setter={setAtividades}
                    defaultData={mountedData?.atividades || []}
                    setterSoma={setHoraTotal}
                    setterSomaLib={setHoraSaldo}
                    gerarProjeto={true}
                  />
                </div>
              </div>
            </div>
            <div className={abaAtiva == 2 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AcessosList setter={setAcessos} defaultData={mountedData?.acessos || []} />
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
      <div className="footer">
        <Label title="Etapa *" className="no-margin" row={true}>
          <Select
            required="true"
            isString
            list={{ list: etapas, value: 'id', label: 'titulo' }}
            name="idEtapa"
            defaultValue={idEtapa}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setIdEtapa(parseInt(v));

              const item = etapas.find(data => data?.id === parseInt(v));
              setGerarProjeto(item?.final == 'S' ? true : false);
            }}
          />
        </Label>
        <PrioridadeListColor
          name="idPrioridade"
          setter={setPrioridade}
          defaultData={mountedData?.prioridade}
        />
      </div>
    </Container>
  );
}

export default CreateEditContent;
